export default __webpack_public_path__ + "static/media/trivia.596389e9.png";